import { RECOrderAttributeOptions } from "@/app/lib/format-rec-options";
import { RegistryCode } from "@/app/types/generated/graphql";
import { ANY_REGISTRY_CODE } from "@/app/types/okta.types";

import { useRecOptions } from "../use-rec-options";

export type AllRecOptions = {
  recOptionsByRegistryCode: {
    MRETS: RECOrderAttributeOptions | undefined;
    ERCOT: RECOrderAttributeOptions | undefined;
  };
  mergedRecOptions?: RECOrderAttributeOptions;
  loading: boolean;
};

/**
 * To be used on formatting individual data to construct table data when ANY_REGISTRY is used
 * since not all the registry-specific values are present in the recOptions for ANY_REGISTRY
 */
export const useAllRecOptions = (): AllRecOptions => {
  const { recOptions: mergedRecOptions, loading: recOptionsLoading } = useRecOptions({
    registryCode: ANY_REGISTRY_CODE,
  });
  const { recOptions: mretsRecOptions, loading: mretsRecOptionsLoading } = useRecOptions({
    registryCode: RegistryCode.Mrets,
  });
  const { recOptions: ercotRecOptions, loading: ercotRecOptionsLoading } = useRecOptions({
    registryCode: RegistryCode.Ercot,
  });

  return {
    /**
     * Only registry specific rec options are returned; Not available for `ANY_REGISTRY_CODE`
     */
    recOptionsByRegistryCode: {
      [RegistryCode.Mrets]: mretsRecOptions,
      [RegistryCode.Ercot]: ercotRecOptions,
    },
    mergedRecOptions,
    loading: recOptionsLoading || mretsRecOptionsLoading || ercotRecOptionsLoading,
  };
};
